import { PropertiesService } from "./properties.service";

export function propertiesProviderFactory(
    service: PropertiesService
): () => Promise<boolean> {
    
    return () => service.load();
}
